import {GET_ScrutinyFeedback} from '../constants/ActionTypes'

const INIT_STATE = {
    FeedbackMessage: null,
    //loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_ScrutinyFeedback:
            return {
                FeedbackMessage: action.body,
                //loading :false
            }
        default:
            return state;
    }
}